import {
  HHBox,
  HHTooltip,
  HHTypography,
} from '@hinge-health/react-component-library';
import { formatRelativeTime } from '../utils/format.utils';

interface RelativeTimeCellProps {
  isoDate: string;
  /** Fixed width keeps sibling timestamp columns aligned as text changes. */
  width?: number;
}

/**
 * Relative time ("2 hours ago") with the exact instant on hover and, just as
 * importantly, exposed to assistive tech.
 *
 * HHTooltip wraps `title` in a <span>, so MUI sees a ReactElement rather
 * than a string and never applies `aria-label` to the child itself — the
 * exact timestamp would otherwise be hover-only (WCAG 1.3.1). Labelling it
 * here needs an explicit `role`: a bare <div> has the generic role, which
 * prohibits an authored accessible name, so the label would be dropped.
 * `group` is nameable and is valid inside a table cell.
 */
export const RelativeTimeCell = ({
  isoDate,
  width,
}: RelativeTimeCellProps): JSX.Element => (
  <HHTooltip hhVariant="variant-bypass" title={isoDate}>
    <HHBox role="group" aria-label={isoDate} sx={{ width }}>
      <HHTypography
        hhVariant="variant-bypass"
        variant="body2"
        color="text.secondary"
      >
        {formatRelativeTime(isoDate)}
      </HHTypography>
    </HHBox>
  </HHTooltip>
);
